import "./site-header.css";

const SiteHeader = () => (
  <header className="site-header">
    <h1>NitroBolt Extension Packs</h1>
    <p>Compatibility packs for community extension galleries.</p>
  </header>
);

export default SiteHeader;
